import { action, makeObservable } from "mobx";
import { observer } from "mobx-react";
import * as React from "react";
import type { RepositoryShifts } from "../../domain/repositories/repository-shifts";
import { type UUID } from "../../utils/uuid";
import { ListCommandButtons, type ListCommandButtonsProps } from "./list-command-buttons";
import { FormCreateShift } from "../molecules/form-create-shift";
import { FormUpdateShift } from "../molecules/form-update-shift";

export type ListCommandButtonsShiftsProps = Omit<
    ListCommandButtonsProps<RepositoryShifts>,
    "list" | "createForm" | "listState"
>;

import { store } from "../../store";

@observer
export class ListCommandButtonsShifts extends React.Component<ListCommandButtonsShiftsProps> {
    constructor(props: ListCommandButtonsShiftsProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private async deleteShifts(ids: UUID[]): Promise<void> {
        await store.repositoryShifts.delete(...ids);
        if (this.props.onDelete) {
            this.props.onDelete(ids);
        }
    }
    public render(): JSX.Element {
        return (
            <ListCommandButtons<RepositoryShifts>
                updateForm={FormUpdateShift}
                createForm={FormCreateShift}
                createButtonText={store.i18n.t("page.systemWide.shift.createButton.text")}
                createDialogTitle={store.i18n.t("page.systemWide.shift.createDialog.title")}
                updateDialogTitle={store.i18n.t("page.systemWide.shift.updateDialog.title")}
                listState={store.serviceListStates.shifts}
                {...this.props}
                onDelete={this.deleteShifts}
            />
        );
    }
}
